<template>
  <div class="recent-tracks flex box">
    <h3 class="list-heading flex m-a-between s-a-center no-select" @click="expanded = !expanded">Recent tracks <span class="flex m-a-center s-a-center"><svg class="expand-recent-tracks" :class="{active: expanded === true}" width="30" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg></span></h3>
    <ul class="track-list" :class="{expanded: expanded === true}">
        <li class="track flex m-a-between" v-for="(track, index) in tracks" :key="index">
            <span class="track-name"><a target="blank" :href="`https://open.spotify.com/track/${track.track.id}`">{{track.track.name}}</a></span>
            <span class="track-details">{{track.track.artists[0].name}}</span>
        </li>
    </ul> 
  </div>    
</template>

<script>

export default {
  name: 'recentListens',
  props: ['tracks'],
  data: () => {
    return {
      expanded: false,
    }
  },
}
</script>

<style scoped>
  .recent-tracks {
    margin: 0rem 1rem 1rem 1rem;
  }
  .list-heading {
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0); 
  }
  .list-heading { margin: 1rem; width: 100%;}
  .track-name {
    color: #454F8C;
    font-weight: bold;
  }
  .track-list {
    list-style: none;
    padding: 0;
    width: 100%;
  }
  .track {
    padding: .5rem 1rem;
    color: #454F8C;
  }
  .track:nth-child(2n+1) {
    background: #f3f3f3;
  }
  .expand-recent-tracks {
    cursor: pointer;
    transition: transform .2s ease;
    transform-origin: center center;
    transform-box: fill-box;
    opacity: 0;
  }
  .expand-recent-tracks.active {
    transform: rotate(180deg);
  }
  @media screen and (max-width: 1024px) { 
    .expand-recent-tracks {
      opacity: 1;
    }
    .recent-tracks {
      width: 100%;
    }
    .track-list {
      transform: scaleY(0);
      transform-origin: 0 0;
      height: 0;
    }
    .track-list.expanded {
      transform: scaleY(1);
      height: auto;
    }
  }
</style>